import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { Domain } from '~src/settings/dataconnect-settings/sections/types/Domain';

export type DeleteDataConnectPoolDialogProps = Readonly<{
  poolName: string;
  hasNodes: boolean;
  hasDomains: boolean;
  domains: Domain[];
}>
export type DeleteDataConnectPoolDialogState = Readonly<{
  isPending: boolean;
}>

const dialogClass = style({ marginBottom: 30, whiteSpace: 'break-spaces' });
const listClass = style({ maxHeight: 100, overflowY: 'auto', overflowX: 'clip' });
const listItemClass = style({ listStyleType: 'none', paddingInlineStart: TabStyles.Spacing.LargeSpace });

export function DeleteDataConnectPoolDialogBody(props: DeleteDataConnectPoolDialogProps) {
  return (
    <div className={dialogClass}>
      <div>{getDeletePoolMessage(props)}</div>
      <div className={listClass}>
        {props.hasDomains &&
          <ul id='domainList' className={listItemClass}>
            {props.domains.map(domain => {
              return <li key={domain.domainName}>{domain.domainName}</li>;
            })}
          </ul>
        }
      </div>
    </div>
  );
}

function getDeletePoolMessage(props: DeleteDataConnectPoolDialogProps) {
  let message = Messages.dataConnectSiteSettingsDeletePoolWarning({ POOL_NAME: L10n.elideIfLong(props.poolName) });
  if (props.hasNodes && props.hasDomains) {
    message += ' ' + Messages.dataConnectSiteSettingsDeletePoolWithNodesAndDomains();
  }
  else if (props.hasNodes) {
    message += ' ' + Messages.dataConnectSiteSettingsDeletePoolWithNodes();
  }
  else if (props.hasDomains) {
    message += ' ' + Messages.dataConnectSiteSettingsDeletePoolWithDomains();
  }
  return message;
}
